import useGReCaptcha from './useGReCaptcha';

export default useGReCaptcha;
